// import './Logo.css'
import logoMobile from '../img/mobile/logo01.png';
import logoPc from '../img/logo01.png';

function Logo({ isMobile }) {
    return (
        <h1 className="logo01"><a id="log-link" href="http://www.nims.go.kr/?sub_num=911" target="_blank"><img src={isMobile ? logoMobile : logoPc} alt="국립기상과학원" /></a></h1>
    )
}

export default Logo;